import React from "react";
import { Form, Formik } from "formik";
import { useJetpackConfigSelector } from "../../../redux/jetpackConfig";
import { type StepProps } from "../JetpackOnboarding";
import KC_Heading1 from "../../../designsystem/typography/KC-Heading/KC_Heading1";
import KC_Text from "../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Sizes,
  KC_Text_Sizes,
  KC_Weights
} from "../../../designsystem/ds_commons";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../designsystem/KC_Button/KC_Button";
import KC_Separator from "../../../designsystem/KC_Separator/KC_Separator";
import Rocket from "../../../designsystem/KC_OnboardingStepper/Rocket";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import type BusinessUser from "@tootsweet/model/entities/BusinessUser";
import { tt } from "../../../utils/i18n/i18n";
import "./styles.scss";

export default function LastStep(props: StepProps) {
  const jetpackConfig = useJetpackConfigSelector();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const handleSubmit = async () => {
    props.nextStep();
  };

  if (jetpackConfig == null) {
    return <div>Erreur</div>;
  }

  if (!accountToDisplay?.businessUser) {
    return null;
  }

  return (
    <div id="final-step">
      <div
        className="d-flex justify-content-center pt-5"
        style={{ gap: "80px" }}
      >
        <div style={{ width: "400px", position: "relative" }} className="pt-5">
          <div>
            <Rocket className="rocket" />
          </div>
          <KC_Separator size={KC_Sizes.xl} />
          <KC_Separator size={KC_Sizes.xl} />
          <KC_Separator size={KC_Sizes.xl} />

          <Formik<BusinessUser>
            initialValues={accountToDisplay.businessUser}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {() => {
              return (
                <Form>
                  <div style={{ maxWidth: 460 }}>
                    <KC_Heading1
                      text={tt("jp_onboarding_game_ready_text")}
                      className="text-center"
                    />
                    <KC_Separator size={KC_Sizes.m} />
                    <div className="w-100 d-flex flex-column">
                      <KC_Text
                        size={KC_Text_Sizes.lg}
                        weight={KC_Weights.reg}
                        text={tt("jp_onboarding_game_preview_text_1")}
                        className="text-center"
                      />
                    </div>
                    <KC_Separator size={KC_Sizes.m} />
                    <KC_Button
                      id="submit-btn"
                      className="submit-btn d-none d-sm-flex"
                      text={tt("jp_finalize_button_text")}
                      type={KC_ButtonType.Submit}
                      size={KC_ButtonSize.Giant}
                    />
                    <KC_Button
                      id="submit-btn"
                      className="submit-btn d-flex d-sm-none position-fixed"
                      extraStyle={{
                        bottom: 0
                      }}
                      text={tt("jp_finalize_button_text")}
                      type={KC_ButtonType.Submit}
                      size={KC_ButtonSize.Giant}
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
}
